<template>
  <div>
    <div class="tabbar">
      <van-tabbar v-model="active" :active-color="variables.theme" :fixed="false" route>
        <!-- 智控Tab（原物联入口，方舱/新方舱入口已移至智控页内按权限展示） -->
        <van-tabbar-item
          replace
          :to="{name: 'Iot'}"
          :icon="iot1"
          :active-icon="iot2"
        >
          智控
          <template #icon="props">
            <img :src="props.active ? iot2 : iot1">
          </template>
        </van-tabbar-item>
        <!-- 旧方舱Tab，已注释：入口改为智控页内按权限展示 -->
        <!--        <van-tabbar-item-->
        <!--          v-if="showOldMushTab"-->
        <!--          replace-->
        <!--          :to="{name: 'Mush'}"-->
        <!--          :icon="mush1"-->
        <!--          :active-icon="mush2"-->
        <!--        >-->
        <!--          方舱-->
        <!--          <template #icon="props">-->
        <!--            <img :src="props.active ? mush2 : mush1">-->
        <!--          </template>-->
        <!--        </van-tabbar-item>-->
        <!-- 新方舱Tab，已注释：入口改为智控页内按权限展示 -->
        <!--        <van-tabbar-item-->
        <!--          v-if="showNewMushTab"-->
        <!--          replace-->
        <!--          :to="{name: 'MushNew'}"-->
        <!--          :icon="mushNew1"-->
        <!--          :active-icon="mushNew2"-->
        <!--        >-->
        <!--          新方舱-->
        <!--          <template #icon="props">-->
        <!--            <img :src="props.active ? mushNew2 : mushNew1">-->
        <!--          </template>-->
        <!--        </van-tabbar-item>-->
        <van-tabbar-item replace :to="{name: 'Server'}" :icon="server1" :active-icon="server2">服务
          <template #icon="props">
            <img :src="props.active ? server2 : server1">
          </template>
        </van-tabbar-item>
        <van-tabbar-item replace :to="{name: 'Home'}" :icon="shop1" :active-icon="shop2">商城
          <template #icon="props">
            <img :src="props.active ? shop2 : shop1">
          </template>
        </van-tabbar-item>
        <!--        <van-tabbar-item :to="{name: 'Cart'}" icon="shopping-cart" :badge="totalCartNum">购物车</van-tabbar-item>-->
        <van-tabbar-item replace :to="{name: 'User'}" :icon="mine1" :active-icon="mine2">我的
          <template #icon="props">
            <img :src="props.active ? mine2 : mine1">
          </template>
        </van-tabbar-item>
      </van-tabbar>
    </div>
    <div class="tabbar--placeholder" style="width:100%;height:50px" />
  </div>
</template>

<script>
import variables from '@/styles/variables.scss'
import { getCartGoodsCount } from '@/api/cart'

export default {
  data() {
    return {
      mush1: require(`@/assets/images/mushroom1.jpg`),
      mush2: require(`@/assets/images/mushroom2.jpg`),
      mushNew1: require(`@/assets/images/mushroom1.jpg`), // 新方舱图标，暂时使用相同图标，后续可替换
      mushNew2: require(`@/assets/images/mushroom2.jpg`), // 新方舱图标，暂时使用相同图标，后续可替换
      iot1: require(`@/assets/images/iot1.jpg`),
      iot2: require(`@/assets/images/iot2.jpg`),
      server1: require(`@/assets/images/server1.png`),
      server2: require(`@/assets/images/server2.png`),
      shop1: require(`@/assets/images/shop1.png`),
      shop2: require(`@/assets/images/shop2.png`),
      mine1: require(`@/assets/images/mine1.png`),
      mine2: require(`@/assets/images/mine2.png`),
      active: 0,
      count: 0
    }
  },
  computed: {
    variables() {
      return variables
    },
    totalCartNum() {
      if (this.count === 0) {
        return ''
      } else {
        return this.count <= 99 ? this.count : 99
      }
    }
  },
  mounted() {
    this.getCartGoodsCount()
  },
  methods: {
    getCartGoodsCount() {
      getCartGoodsCount().then(res => {
        const { data } = res
        this.count = data
      }).catch(e => {
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.van-tabbar {
  height: 55px;
}

.tabbar {
  height: 6.6vh;
  width: 100vw;
  position: fixed;
  bottom: 0;
  left: 0;
  border-top: 2px solid #f5f5f5;
}
</style>
